module.exports = __webpack_public_path__ + "static/media/face-screaming-in-fear-svgrepo-com.32f86bb3.svg";